import React, { useState } from "react";
import { arrayOf, bool, shape, string } from "prop-types";

import ExpandableList from "../ExpandableList";
import * as S from "./styled";

const NeighborhoodSection = ({ isExpandedAreaSection, neighborhoods }) => {
  const [isSectionShown, setSectionShown] = useState(false);
  const handleClick = () => setSectionShown(true);

  return (
    <>
      <S.ShowButton
        isContentShown={isSectionShown}
        isExpandedAreaSection={isExpandedAreaSection}
        onClick={handleClick}
      >
        <span aria-hidden="true">+&nbsp;&nbsp;</span>show nyc neighborhoods
      </S.ShowButton>
      <S.Wrapper
        isExpandedAreaSection={isExpandedAreaSection}
        isShown={isSectionShown}
      >
        {neighborhoods.map(
          ({
            descendents: subNeighborhoods,
            name: headerText,
            url: headerUrl
          }) => (
            <ExpandableList
              key={headerText}
              headerText={headerText}
              headerUrl={headerUrl}
              list={subNeighborhoods}
            />
          )
        )}
      </S.Wrapper>
    </>
  );
};

NeighborhoodSection.propTypes = {
  isExpandedAreaSection: bool,
  neighborhoods: arrayOf(
    shape({
      name: string,
      url: string,
      descendents: arrayOf(shape({ name: string, url: string }))
    })
  )
};

NeighborhoodSection.defaultProps = {
  isExpandedAreaSection: false,
  neighborhoods: []
};

export default NeighborhoodSection;
